import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import iconeEncontreSuaAgencia from '../../../assets/img/icones/personalizados/agencia-cor.svg';
import iconeCadeado from '../../../assets/img/icones/personalizados/cadeado-cor.svg';
import iconeEmail from '../../../assets/img/icones/personalizados/carta-cor.svg';
import iconeCelular from '../../../assets/img/icones/personalizados/celular-cor.svg';
import iconeUsuarioComVisto from '../../../assets/img/icones/personalizados/comercial-visto.svg';
import {
  default as iconeBuscaCep,
  default as iconeMapa,
} from '../../../assets/img/icones/personalizados/mapa-cor.svg';
import iconeMinhasImportacoes from '../../../assets/img/icones/personalizados/mundo-cor.svg';
import iconeOrganograma from '../../../assets/img/icones/personalizados/organograma-usuarios.svg';
import iconePrecosEPrazos from '../../../assets/img/icones/personalizados/precos-prazos-cor.svg';
import iconeRastreioObjeto from '../../../assets/img/icones/personalizados/rastreamento-cor.svg';
import iconeEscudoComCadeado from '../../../assets/img/icones/personalizados/seguranca-cor.svg';
import iconeCelularComMensagem from '../../../assets/img/icones/personalizados/sms-token-cor.svg';
import iconeOuvidoria from '../../../assets/img/icones/personalizados/ouvidoria-cor.svg';
import useFetch from '../../../components/hooks/useFetch.js';
import { ENDERECOS_PESQUISA } from '../../../services/endereco.js';
import { MEUCORREIOS_PESQUISA, VALIDA_CPF_DATA } from '../../../services/meuCorreios.js';
import './telaPrincipal.scss';
//import { PESQUISAR_CONTRATOS_PJ } from '../../../services/delegacao';
import { useLocation } from 'react-router-dom';
import ModalAjuda from '../../../components/modal/ModalAjuda.js';
import ModalDialog from '../../../components/modal/ModalDialog.js';
import MessageModal from '../../../components/modal/MessageModal.js';
import { AuthContext } from '../../../store/AuthContext.js';
import FormAjuda from './FormAjudaModal.js';
import FormAlterarEmail from './FormAlterarEmail.js';
import FormAlterarSenha from './FormAlterarSenha.js';
import FormAlterarTelefone from './FormAlterarTelefone.js';
import FormExcluirConta from './FormExcluirConta.js';
import { UserContext } from '../../../store/UserContext';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFormSchemas } from '../Cadastro/FormSchema.js';
import InputCpf from '../../../components/form/InputCpf.js';
import InputCadastro from '../../../components/form/InputCadastro.js';
import { getIPAddress } from '../../../components/utils/GetIPAddress.js';
import { toast } from 'react-toastify';

const TelaPrincipalPJ = () => {
  const { t } = useTranslation();
  const { request } = useFetch();
  const origem = window.localStorage.getItem('origem');
  const { request: requestMeuCorreios, data: dadosCNPJ } = useFetch();
  const { request: requestEnderecos, data: dadosEnderecos } = useFetch();
  //const { request: requestContrato, data: dadosContrato } = useFetch();
  const [endereco, setEndereco] = useState();
  const [modalAbertoAjuda, setModalAbertoAjuda] = useState(false);
  const [modalAbertoEmail, setModalAbertoEmail] = useState(false);
  const [modalAbertoSenha, setModalAbertoSenha] = useState(false);
  const [modalAbertoTelefone, setModalAbertoTelefone] = useState(false);
  const [modalAbertoHistoricoToken, setModalAbertoHistoricoToken] =
    useState(false);
  const [modalAbertoExcluirConta, setModalAbertoExcluirConta] = useState(false);
  const { user, newSession } = useContext(AuthContext);
  const idCorreios = user?.sub;
  const [telefone, setTelefone] = useState();
  const navigate = useNavigate();
  const [alterei, setAlterei] = useState(false);
  const isInitialRender = useRef(true);
  const location = useLocation();
  const dados = location.state;
  const dadosUsuario = dados[0];
  const dadosContrato = dados[1];
  const { setUsuario } = useContext(UserContext);

  const [ipAddress, setIpAddress] = useState('');
  const { formSchemaCPFData } = createFormSchemas(t);

  const methods = useForm({ 
    resolver: yupResolver(formSchemaCPFData) ,
    mode: 'onChange',
  });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.formState.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const formatarCnpj = (cnpj) => {
    if (!cnpj) return '';

    const cnpjLimpo = cnpj.toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (cnpjLimpo.length !== 14) return cnpj;

    return `${cnpjLimpo.slice(0, 2)}.${cnpjLimpo.slice(2, 5)}.${cnpjLimpo.slice(5, 8)}/${cnpjLimpo.slice(8, 12)}-${cnpjLimpo.slice(12, 14)}`;
  };

  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    if (dadosCNPJ) {
      //setUsuario(dadosCNPJ);
      requestEnderecos(ENDERECOS_PESQUISA(idCorreios));
      //requestContrato(PESQUISAR_CONTRATOS_PJ(idCorreios, 'PJ'));
      if (dadosCNPJ?.usuarioExternoPJ?.sediadaForaBrasil === 'N') {
        if (!dadosCNPJ?.foneMovel) {
          setTelefone('');
        } else {
          setTelefone(
            '(' +
              dadosCNPJ?.dddMovel +
              ')' +
              dadosCNPJ?.foneMovel.replace(/(\d{5})(\d{4})/, '$1-$2'),
          );
        }
      } else {
        let ddi = '';
        if (dadosCNPJ?.ddiMovel != undefined) {
          ddi = dadosCNPJ?.ddiMovel;
        }
        setTelefone(
          ddi +
            ' (' +
            dadosCNPJ?.dddMovel +
            ')' +
            dadosCNPJ?.foneMovel,
        );
      }
      setAlterei(false);
    }
  }, [dadosCNPJ]);
  useEffect(() => {
    var enderecoBanco = '';
    dadosEnderecos?.forEach((endereco) => {
      if (endereco.principal == 'S') {
        enderecoBanco = endereco.logradouro;
        if (endereco.numero) {
          enderecoBanco += ', ' + endereco.numero;
        }
        if (endereco.complemento) {
          enderecoBanco += ', ' + endereco.complemento;
        }
        if (endereco.bairro) {
          enderecoBanco += ', ' + endereco.bairro;
        }
        enderecoBanco +=
          ', ' +
          endereco.cidade +
          ', ' +
          endereco.uf +
          ', ' +
          endereco.nomePais;

        setEndereco(enderecoBanco);
      }
    });
  }, [dadosEnderecos]);

  const fechar = () => {
    setModalAbertoTelefone(false);
    setModalAbertoEmail(false);
    //setModalAbertoDadosBrasileiro(false);
    setAlterei(true);
  };
  useEffect(() => {
    if (idCorreios && idCorreios != '')
      requestMeuCorreios(MEUCORREIOS_PESQUISA(idCorreios));
    else navigate('/login');
  }, [alterei]);

  const chamaEndereco = () => {
    navigate('/endereco', { state: dadosEnderecos });
  };
  const chamaHistoricoToken = () => {
    navigate('/historicoToken', { state: dadosCNPJ });
  };
  const chamaAlterarDados = () => {
    if (dadosCNPJ?.usuarioExternoPJ?.sediadaForaBrasil === 'N')
      navigate('/dadosPJBrasil', { state: dadosCNPJ });
    else {
      navigate('/dadosPJForaBrasil', { state: dadosCNPJ });
    }
  };
  const chamaTereceiroDelegar = () => {
    navigate('/permitirDelegar', { state: dadosCNPJ });
  };
  const chamaDelegacaoAcesso = () => {
    navigate('/delegacaoAcesso', { state: { dados: dadosCNPJ } });
  };

  const abrirModalEmail = async () => {
    const telefoneCadastrado = dadosCNPJ?.foneMovel?.toString().trim();

    if (telefoneCadastrado) {
      setModalAbertoEmail(true);
    } else {
      toast(
        ({ closeToast }) => (
          <MessageModal
            msgSuperior="Para realizar a alteração do e-mail cadastrado é necessário informar o número de telefone vinculado ao cadastro. A solicitação deve ser feita por meio do Fale Conosco com o envio das cópias do Contrato Social (ou ata/portaria/ato constitutivo), procuração legal, se houver e RG do representante legal."
            msgInferior=""
            textoDoLink="Clique aqui para acessar o Fale Conosco."
            href="https://faleconosco.correios.com.br/faleconosco/app/cadastro/suporte/tecnologico-mc/index.php"
            onClick={closeToast}
          />
        ),
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
        },
      );
    }
  };

  const abrirModalTelefone = async () => {
    const emailCadastrado = dadosCNPJ?.email?.toString().trim();

    if (emailCadastrado) {
      setModalAbertoTelefone(true);
    } else {
      toast(
        ({ closeToast }) => (
          <MessageModal
            msgSuperior="Para realizar a alteração do telefone cadastrado é necessário informar o e-mail vinculado ao cadastro. A solicitação deve ser feita por meio do Fale Conosco com o envio das cópias do Contrato Social (ou ata/portaria/ato constitutivo), procuração legal, se houver e RG do representante legal."
            msgInferior=""
            textoDoLink="Clique aqui para acessar o Fale Conosco."
            href="https://faleconosco.correios.com.br/faleconosco/app/cadastro/suporte/tecnologico-mc/index.php"
            onClick={closeToast}
          />
        ),
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
        },
      );
    }
  };

  const onConfirmarDados = async (data) => {
    
  const formatDateISOWithoutShift = (date) => {
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    )).toISOString();
  };
  const newData = {
    ...data,
    idCorreios: idCorreios,
    dataNascimento: formatDateISOWithoutShift(data.dataNascimento)
  };
  const { response } = await request(VALIDA_CPF_DATA(newData, ipAddress),);
    if (response.ok) {
      setUsuario(dadosCNPJ)
      localStorage.removeItem("visibleCPFData");
    }
  };
  
  const visibleCPFData = localStorage.getItem("visibleCPFData"); 
  if (visibleCPFData == "true" && 
      (dadosCNPJ?.usuarioExternoPJ?.sediadaForaBrasil === 'N' || 
      (dadosCNPJ?.usuarioExternoPJ?.sediadaForaBrasil === 'S' && dadosCNPJ?.usuarioExternoPJ?.cnpj != undefined))) {
    return (
      <div className="dialog-container">
        <div className="dialog-main" 
             style={{ 
                backgroundColor: "#fff", 
                border: "1px solid #aaa", 
                borderRadius: "12px", 
                padding: "20px", 
                width: "auto", 
                margin: "40px auto", 
                boxShadow: "0 12px 30px rgba(0,0,0,0.35)", 
                fontFamily: "Arial, sans-serif" 
              }}
          >
        
          <div className="modal-validacao">
            <h5>{t('cadastro.titles.confirme_RL')}</h5>
            <h6>{t('cadastro.forms.labels.prop_resp_socio_procurador')}</h6>
            <br />
            <form id="formCPFData" onSubmit={methods.handleSubmit(onConfirmarDados)}>

              <InputCpf
                label={t('cadastro.forms.labels.cpf')}
                type="text"
                id="cpf"
                name="cpf"
                //onBlur={handleCPF}
                {...formMethods}
              />

              <InputCadastro
                className="input-data"
                type="date"
                id="dataNascimento"
                name="dataNascimento"
                label={t('cadastro.forms.labels.birth_date')}
                {...formMethods}
                //disabled={desabilitarCampo}
              />

              <div className="btns-row">
                <button
                  id="btn-prosseguir"
                  type="submit"
                  className="btn-pre primario"
                  disabled={!methods.formState.isValid}
                >
                  {t('cadastro.forms.buttons.continue')}
                </button>

                <button
                  id="btn-voltar"
                  type="button"
                  className="btn-txt"
                  onClick={() => newSession()}
                >
                  {t('cadastro.forms.buttons.cancel')}
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="conteudoTP">
        {origem && origem == 'meuCorreios' && (
          <>
            <div className="titulo-bem-vindoTP">
              <h1 className="msg-bemvindoTP">{t('telaPrincipal.welcome')}</h1>
              <button
                type="button"
                id="btn-ajuda"
                className="btn-txt"
                onClick={() => setModalAbertoAjuda(true)}
              >
                <i className="ic-duvida"></i>
                {t('telaPrincipal.help')}
              </button>
            </div>

            {dadosContrato.length === 0 ? (
              <a
                target="_blank"
                href="https://www.correios.com.br/correios-facil"
                className="banner-contrate"
              >
                <picture>
                  <source
                    srcSet="/images/header-mobile.png"
                    media="(max-width: 599px)"
                    type="image/png"
                  />

                  <img
                    src="/images/header-desktop.png"
                    alt={t('telaPrincipal.contractCorreios')}
                  />
                </picture>
              </a>
            ) : (
              <a
                target="_blank"
                href="https://empresas.correios.com.br"
                className="banner-contrate"
              >
                <picture>
                  <source
                    srcSet="/images/banner-pj-correios-empresas-mobile.png"
                    media="(max-width: 599px)"
                    type="image/png"
                  />

                  <img
                    src="/images/banner-pj-correios-empresas.png"
                    alt={t('telaPrincipal.contractCorreios')}
                  />
                </picture>
              </a>
            )}
          </>
        )}
        <div id="perfil" className="card bg-superficie elev1">
          <div id="dados">
            <div>
              <div id="nomeUsuario" className="t2">
                {dadosCNPJ?.nome}
              </div>
              <div className="titulo-texto">
                <h6>{t('telaPrincipal.user')}:</h6>
                <div>{dadosCNPJ?.idCorreios}</div>
              </div>
              <div className="titulo-texto">
                <h6>{t('telaPrincipal.tradeName')}:</h6>
                <div>{dadosCNPJ?.usuarioExternoPJ?.nomeFantasia}</div>
              </div>

              {dadosCNPJ?.usuarioExternoPJ?.cnpj && (
                <div className="titulo-texto">
                  <h6>{t('telaPrincipal.cnpj')}:</h6>
                  <div>{formatarCnpj(dadosCNPJ?.usuarioExternoPJ?.cnpj)}</div>
                </div>
              )}
              {dadosCNPJ?.usuarioExternoPJ?.an8 && (
                <div className="titulo-texto">
                  <h6>{t('telaPrincipal.an8')}:</h6>
                  <div>{dadosCNPJ?.usuarioExternoPJ?.an8}</div>
                </div>
              )}
              {!dadosCNPJ?.responsavel && (
                <button
                  id="btn-abrir-dados"
                  className="btn-txt"
                  onClick={() => chamaAlterarDados()}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editData')}
                </button>
              )}
            </div>
          </div>

          <hr />

          <div id="dados-separados">
            <div className="dado-separado-container">
              <div>
                <img
                  className="img-card"
                  alt="ícone de e-mail"
                  src={iconeEmail}
                />
                <div>
                  <h6>{t('telaPrincipal.email')}:</h6>
                  {dadosCNPJ?.email}
                </div>
              </div>
              {!dadosCNPJ?.responsavel && (
                <button
                  id="btn-abrir-email"
                  className="btn-txt"
                  onClick={abrirModalEmail}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editEmail')}
                </button>
              )}
            </div>

            <div className="dado-separado-container">
              <div>
                <img
                  className="img-card"
                  alt="ícone de telefone"
                  src={iconeCelular}
                />
                <div>
                  <h6>{t('telaPrincipal.phone')}:</h6>
                  {telefone}
                </div>
              </div>
              {!dadosCNPJ?.responsavel && (
                <button
                  id="btn-abrir-tel"
                  className="btn-txt"
                  onClick={abrirModalTelefone}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editPhone')}
                </button>
              )}
            </div>
            {!dadosCNPJ?.responsavel && (
              <div className="dado-separado-container">
                <div>
                  <img
                    className="img-card"
                    alt="ícone de cadeado"
                    src={iconeCadeado}
                  />
                  <div>
                    <h6>{t('telaPrincipal.password')}:</h6>
                    {t('telaPrincipal.passwordMessage')}
                  </div>
                </div>
                <button
                  id="btn-abrir-senha"
                  className="btn-txt"
                  onClick={() => setModalAbertoSenha(true)}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editPassword')}
                </button>
              </div>
            )}
          </div>
        </div>
        {!dadosCNPJ?.responsavel && (
          <>
            <div id="endereco" className="card bg-superficie elev1">
              <div>
                <img
                  className="img-card"
                  alt="ícone de mapa com pin"
                  src={iconeMapa}
                />
                <h3>{t('principal.addresses.title')}</h3>
              </div>

              <div className="card-descricao">
                <b>{t('telaPrincipal.mainAddress')}:</b>
                <br />
                {endereco}
              </div>

              <button className="btn-txt" onClick={() => chamaEndereco()}>
                <i className="ic-busca-cep"></i>
                {t('telaPrincipal.manageAddresses')}
              </button>
            </div>

            <div id="token" className="card bg-superficie elev1">
              <div>
                <img
                  className="img-card"
                  alt="ícone de celular com mensagem de texto"
                  src={iconeCelularComMensagem}
                />
                <h3>{t('principal.help.token_history.title')}</h3>
              </div>

              <div className="card-descricao">
                {t('telaPrincipal.tokenHistoryDescription')}
              </div>

              <button className="btn-txt" onClick={() => chamaHistoricoToken()}>
                <i className="ic-celular"></i>
                {t('telaPrincipal.consult')}
              </button>
            </div>

            {(dadosCNPJ?.usuarioExternoPJ?.cnpj ||
              dadosCNPJ?.usuarioExternoPJ?.an8) && (
              <>
                <div id="delegacao" className="card bg-superficie elev1">
                  <div>
                    <img
                      className="img-card"
                      alt="ícone de usuário com um visto"
                      src={iconeUsuarioComVisto}
                    />
                    <h3>{t('telaPrincipal.accessDelegation')}</h3>
                  </div>

                  <div className="card-descricao">
                    {t('telaPrincipal.accessDelegationDescription')}
                  </div>

                  <button
                    className="btn-txt"
                    onClick={() => chamaDelegacaoAcesso()}
                  >
                    <i className="ic-usuario-visto"></i>
                    {t('telaPrincipal.delegateAccess')}
                  </button>
                </div>

                <div
                  id="delegacao-terceiros"
                  className="card bg-superficie elev1"
                >
                  <div>
                    <img
                      className="img-card"
                      alt="ícone de um organograma"
                      src={iconeOrganograma}
                    />
                    <h3>{t('telaPrincipal.allowThirdPartyDelegation')}</h3>
                  </div>

                  <div className="card-descricao">
                    {t('telaPrincipal.allowThirdPartyDelegationDescription')}
                  </div>

                  <button
                    className="btn-txt"
                    onClick={() => chamaTereceiroDelegar()}
                  >
                    <i className="ic-usuario-adicionar"></i>
                    {t('telaPrincipal.addThirdParty')}
                  </button>
                </div>
              </>
            )}
          </>
        )}
        <div id="privacidade" className="card bg-superficie elev1">
          <div>
            <img
              className="img-card"
              alt="ícone de escudo com cadeado"
              src={iconeEscudoComCadeado}
            />
            <h3>{t('telaPrincipal.privacyPolicy')}</h3>
          </div>

          <div className="card-descricao">
            {t('telaPrincipal.accessThe')}&ensp;
            <a
              className="txt-link"
              href="https://www.correios.com.br/falecomoscorreios/politica-de-privacidade-e-cookies"
              target="_blank"
            >
              {t('telaPrincipal.privacyPolicyLink')}
            </a>
            . {t('telaPrincipal.privacyPolicyMessagePJ')}
          </div>
        </div>

        {/* BANNER DE PESQUISA DESATIVADO
        <a
          target="_blank"
          href="https://c.correios.com.br/meu-correios"
          className="banner-contrate"
        >
          <picture>
            <source
              srcSet="/images/Banner-pesquisa-mob.png"
              media="(max-width: 599px)"
              type="image/png"
            />

            <img
              src="/images/Banner-pesquisa.png"
              alt={t('telaPrincipal.contractCorreios')}
            />
          </picture>
        </a> */}

        <div id="excluir-conta">
          <h6>{t('telaPrincipal.deactivateAccount')}</h6>
          <p>
            {t('telaPrincipal.deactivateAccountMessage')}&ensp;
            <a
              id="abrir-excluir-conta"
              className="txt-link"
              onClick={() => setModalAbertoExcluirConta(true)}
            >
              {t('telaPrincipal.deactivateAccountConfirm')}
            </a>
          </p>
        </div>
      </div>
      {origem && origem == 'meuCorreios' && (
        <div id="acesso-rapido" className="bg-azul-correios">
          <div className="acesso-rapido-container">
            <h2>{t('telaPrincipal.quickAccess')}</h2>
            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://rastreamento.correios.com.br/app/index.php"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de rastreio de objetos"
                  src={iconeRastreioObjeto}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.trackYourObject')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://www2.correios.com.br/sistemas/precosPrazos/"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de preços e prazos"
                  src={iconePrecosEPrazos}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.pricesAndDeadlines')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone do busca cep ou endereço"
                  src={iconeBuscaCep}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.searchZipAddress')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://cas.correios.com.br/login?service=https%3A%2F%2Fapps.correios.com.br%2Fportalimportador%2Fpages%2FpesquisarRemessaImportador%2FpesquisarRemessaImportador.jsf"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de minhas importações"
                  src={iconeMinhasImportacoes}
                />
                <p className="subtitulo-p">{t('telaPrincipal.myImports')}</p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://buscaagencia.correios.com.br/"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de encontre sua agência"
                  src={iconeEncontreSuaAgencia}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.findYourAgency')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://c.correios.com.br/meu-correios"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de balão de conversa"
                  src={iconeOuvidoria}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.rateSignUpExperience')}
                </p>
              </a>
            </div>
          </div>
        </div>
      )}
      <ModalAjuda
        aberto={modalAbertoAjuda}
        setAberto={setModalAbertoAjuda}
        opcaoFechar={true}
      >
        <FormAjuda acaoCancelar={() => setModalAbertoAjuda(false)} />
      </ModalAjuda>
      <ModalDialog
        titulo={t('telaPrincipal.editEmail')}
        id="moda-email"
        aberto={modalAbertoEmail}
        setAberto={setModalAbertoEmail}
        opcaoFechar={true}
      >
        <FormAlterarEmail
          acaoCancelar={() => setModalAbertoEmail(false)}
          acaoFechar={fechar}
          dados={dadosCNPJ}
        />
      </ModalDialog>
      <ModalDialog
        titulo={t('telaPrincipal.editPassword')}
        id="modal-senha"
        aberto={modalAbertoSenha}
        setAberto={setModalAbertoSenha}
        opcaoFechar={true}
      >
        <FormAlterarSenha
          acaoCancelar={() => setModalAbertoSenha(false)}
          acaoFechar={fechar}
          dados={dadosCNPJ}
        />
      </ModalDialog>
      <ModalDialog
        titulo={t('telaPrincipal.editPhone')}
        id="modal-teledone"
        aberto={modalAbertoTelefone}
        setAberto={setModalAbertoTelefone}
        opcaoFechar={true}
      >
        <FormAlterarTelefone
          acaoCancelar={() => setModalAbertoTelefone(false)}
          acaoFechar={fechar}
          dados={dadosCNPJ}
        />
      </ModalDialog>
      {/*}<Modal
        titulo="Histórico de tokens"
        id="modal-historico-tokens"
        aberto={modalAbertoHistoricoToken}
        setAberto={setModalAbertoHistoricoToken}
        opcaoFechar={true}
      >
        <FormHistoricoToken
          acaoCancelar={() => setModalAbertoHistoricoToken(false)}
          dados={dadosCNPJ}
        />
      </Modal>*/}
      <ModalDialog
        titulo={t('telaPrincipal.deactivateAccount')}
        id="modal-excluir-conta"
        aberto={modalAbertoExcluirConta}
        setAberto={setModalAbertoExcluirConta}
        opcaoFechar={true}
      >
        <FormExcluirConta
          acaoCancelar={() => setModalAbertoExcluirConta(false)}
          dados={dadosCNPJ}
          tipoPessoa="2"
        />
      </ModalDialog>
    </>
  );
};

export default TelaPrincipalPJ;
